export default __webpack_public_path__ + "static/media/gifcase2.c2968d3e.svg";